import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {InteractionStatus} from '../model/model';

import {environment} from 'environment';
import {AuthRequest} from '../../auth-request/auth-request';

@Injectable()
export class InteractionRepository {

  constructor(
    private _http: HttpClient,
    private _authRequest: AuthRequest,
  ) { }

  public getInteractionStatus(): Observable<InteractionStatus> {

    return this._authRequest.handleRequest(
      this._http.get(environment.reflection.statusRoute, {withCredentials: true}),
    ).pipe(map((response) => <InteractionStatus> response));
  }

}
